import React from "react"
import { Link } from "gatsby"


const ToMainBottomLink = () => {

    return (
        <>
            <Link id="toMainBottomLink" to="/">
               <p>← на главную</p>
            </Link>
        </>
    );
}

export default ToMainBottomLink;